/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Select component.
 */
import React, { Component } from 'react';
import { AutoComplete } from 'material-ui';

class DropDownSearch extends Component {
    render() {
        const {
            onAdd,
            tooltip,
            label,
            dataSource,
            onNewRequest,
            errorText,
            dataSourceConfig,
            searchText,
            onUpdateInput
        } = this.props;

        return (
            <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }}>
                <div style={{ width: '100%' }}>
                    <AutoComplete
                        floatingLabelFixed
                        onUpdateInput={onUpdateInput}
                        floatingLabelText={label}
                        hintText="Seleccionar"
                        filter={AutoComplete.fuzzyFilter}
                        dataSource={dataSource}
                        openOnFocus
                        maxSearchResults={30}

                        onNewRequest={onNewRequest}
                        errorText={errorText}
                        dataSourceConfig={dataSourceConfig}
                        searchText={searchText}
                        listStyle={{ maxHeight: 200, overflow: 'auto', width: 'auto' }}
                        fullWidth={false}
                        style={{width: '100%'}}
                        textFieldStyle={{width: '100%'}}
                    />
                </div>
                {
                    onAdd && <div className="addnew-button">
                        <button onClick={onAdd} title={tooltip}>+</button>
                    </div>
                }
            </div>
        );
    }
}

DropDownSearch.defaultProps = {
    tooltip: 'Agregar Nuevo'
};

export default DropDownSearch;



// WEBPACK FOOTER //
// ./components/data-containers/dropDownSearch.js